import i18n from '../i18n/config';

/**
 * Check if content locale matches the requested locale
 * @param {Object} content - Content object with locale field
 * @param {string} requestedLocale - Requested locale (optional, defaults to current i18n language)
 * @returns {boolean} True if locales match
 */
export const isContentInRequestedLocale = (content, requestedLocale = null) => {
  if (!content || !content.attributes) return true; // No locale data, assume OK
  
  const contentLocale = content.attributes.locale;
  const requested = requestedLocale || i18n.language || 'en';
  
  return contentLocale === requested;
};

/**
 * Add locale mismatch warning to content
 * @param {Object} content - Content object
 * @param {string} requestedLocale - Requested locale (optional)
 * @returns {Object} Content with isTranslated flag
 */
export const checkContentLocale = (content, requestedLocale = null) => {
  if (!content) return content;
  
  const requested = requestedLocale || i18n.language || 'en';
  const contentLocale = content.attributes?.locale;
  
  if (contentLocale && contentLocale !== requested) {
    console.warn(
      `Content not available in ${requested}, showing ${contentLocale} version`
    );
    return {
      ...content,
      isTranslated: false,
      requestedLocale: requested,
      actualLocale: contentLocale
    };
  }
  
  return {
    ...content,
    isTranslated: true
  };
};

/**
 * Check array of content items for locale mismatches
 * @param {Array} contentArray - Array of content objects
 * @param {string} requestedLocale - Requested locale (optional)
 * @returns {Array} Content array with isTranslated flags
 */
export const checkContentArrayLocale = (contentArray, requestedLocale = null) => {
  if (!Array.isArray(contentArray)) return contentArray;
  
  return contentArray.map(item => checkContentLocale(item, requestedLocale));
};
